import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { GetDeviceStatisticsParams } from '../api/useGetDeviceStatistics';
import { GetOrganizationMembersParams } from '../api/useGetOrganizationMembers';
import { parseCmCheckinStatus } from './utils/memberFilters';
import { parseMemberSort } from './utils/memberSort';

type UsePagerProps = () => {
    query: GetOrganizationMembersParams;
    deviceStatisticsQuery: GetDeviceStatisticsParams;
};

const useListQueryParams: UsePagerProps = () => {
    const [searchParams] = useSearchParams();

    return useMemo(() => {
        const offset = searchParams.get('offset') || 0;
        const limit = searchParams.get('limit');
        const online_status = searchParams.get('online_status');
        const state = searchParams.get('state');
        const device_status = searchParams.get('device_status');
        const search = searchParams.get('search') || '';
        const list_version = searchParams.get('list_version');
        const disengaged_reason = searchParams.get('disengaged_reason');
        const checkin_status = searchParams.get('checkin_status');
        const checkin_date = searchParams.get('checkin_date');

        let params = {};
        let deviceStatisticsParams = {};

        if (search) {
            params = { ...params, search };
        }

        if (state) {
            params = { ...params, state };
        }

        if (list_version) {
            params = { ...params, list_version };
        }

        if (online_status) {
            const is_online = online_status === 'online' ? true : false;
            params = { ...params, is_online };
            deviceStatisticsParams = { ...deviceStatisticsParams, is_online };
        }

        if (device_status) {
            params = { ...params, device_status };
            deviceStatisticsParams = { ...deviceStatisticsParams, device_status };
        }

        if (disengaged_reason) {
            params = { ...params, disengaged_reason };
        }

        if (checkin_status) {
            params = { ...params, checkin_status };
        }

        if (checkin_date) {
            params = { ...params, checkin_date };
        }

        const care_manager_ids = searchParams.get('care_manager_ids');
        if (care_manager_ids) {
            params = { ...params, care_manager_ids };
        }

        params = {
            ...params,
            ...parseMemberSort(searchParams),
            ...parseCmCheckinStatus(searchParams),
            limit: limit ? +limit : 10,
            offset
        };

        return {
            query: params,
            deviceStatisticsQuery: deviceStatisticsParams
        };
    }, [searchParams]);
};

export default useListQueryParams;
